(function () {
	function initBlock(blockRoot) {
		if (blockRoot.__elxrAtcInit) return;
		blockRoot.__elxrAtcInit = true;
		var sectionId = blockRoot.getAttribute('data-atc-section-id');
		var blockId = blockRoot.getAttribute('data-atc-block-id');
		/* ── Loading state ───────────────────────────────────────
		   Trigger: click event (fires before form submit, unaffected by
		   submit.preventDefault()). Guard: aria-disabled already set = mid-flight.
		   Reset: MutationObserver on aria-disabled removal (product-form.js
		   line 260). Watching aria-disabled and writing to style/classList is a
		   different attribute, so there is zero observer loop risk.

		   Spinner visibility is controlled via the .hidden class rather than
		   inline display, because base.css has `.hidden { display: none !important }`
		   which beats any inline style without !important. Removing .hidden lets
		   the CSS rule `.atc-spinner:not(.hidden) { display: flex }` take over. */
		function initAtcLoading() {
			var btn = document.getElementById('ProductSubmitButton-' + sectionId);
			if (!btn) return;
		    if (btn.matches('[data-external-link="true"]')) return;

			var spinner  = btn.querySelector('.atc-spinner');
			var textMain = btn.querySelector('.atc-text-main');
			var textLoad = btn.querySelector('.atc-text-loading');
			var mode     = (btn.getAttribute('data-loading-mode') || 'spinner');

			function resetStyles() {
				btn.style.opacity       = '';
				btn.style.pointerEvents = '';
				btn.style.cursor        = '';
				if (spinner) {
					/* Clear any inline display override and restore .hidden so
					   base.css `display:none !important` keeps the spinner invisible. */
					spinner.style.display = '';
					spinner.classList.add('hidden');
				}
				if (textMain) { textMain.style.transform = ''; textMain.style.opacity = ''; }
				if (textLoad) { textLoad.style.transform = 'translateY(100%)'; textLoad.style.opacity = '0'; }
			}

			function applyStyles() {
				btn.style.opacity       = '0.65';
				btn.style.pointerEvents = 'none';
				btn.style.cursor        = 'default';
				if (mode === 'spinner') {
					/* Remove .hidden so CSS `.atc-spinner:not(.hidden) { display:flex }`
					   makes the spinner visible. Setting inline display:flex would be
					   overridden by `.hidden { display:none !important }` in base.css. */
					if (spinner) { spinner.classList.remove('hidden'); }
				} else {
					/* Text mode: product-form.js removes .hidden on every submit, so
					   pin the spinner hidden via inline style (no !important on the CSS
					   flex rule, so our inline none wins). */
					if (spinner) { spinner.style.display = 'none'; }
					if (textMain) { textMain.style.transform = 'translateY(-100%)'; textMain.style.opacity = '0'; }
					if (textLoad) { textLoad.style.transform = 'translateY(0)';     textLoad.style.opacity = '1'; }
				}
			}

			/* Primary trigger: click fires synchronously before any async
			   product-form.js logic, so it is 100% reliable.
			   Guard: if aria-disabled is already set we are mid-flight. */
			btn.addEventListener('click', function () {
				if (btn.hasAttribute('aria-disabled')) return;
				applyStyles();
			});

			/* Reset trigger: watch both aria-disabled removal AND .loading removal.
			   product-form.js's handleSubmitFinally removes both in the same
			   synchronous call (comma-operator chain), so MutationObserver batches
			   them into one callback — resetStyles fires in the exact same microtask
			   as the .loading removal, preventing a single-frame flash of the text
			   carousel at the wrong position. Writing to style/classList (different
			   attributes) causes no observer loop. */
			new MutationObserver(function () {
				if (!btn.hasAttribute('aria-disabled') && !btn.classList.contains('loading')) {
					resetStyles();
				}
			}).observe(btn, { attributes: true, attributeFilter: ['aria-disabled', 'class'] });

			/* Set the correct initial state so text-mode carousel starts off-screen.
			   Matches the CSS defaults; belt-and-suspenders in case CSS is stripped. */
			resetStyles();
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initAtcLoading);
		} else {
			initAtcLoading();
		}

		/* ── Subscribe by default + one-time link ───────────────── */
		function initAtcSubscription() {
			var root = document.getElementById('AtcSubscription-' + blockId);
			if (!root || root.__elxrBound) return;
			root.__elxrBound = true;

			var plan = null;
			try {
				plan = JSON.parse(root.querySelector('[data-atc-sub-plan]').textContent);
			} catch (e) {}
			var planId = root.getAttribute('data-plan-id');
			var subscribeByDefault = root.getAttribute('data-subscribe-default') === 'true';
			var subscribeUiSelector = '.subscribe-selector-wrapper, .subscribe-save-wrapper, .subscribe-save-wrapper-dynamic';

			function formReady() {
				return typeof Elixir_ProductFormExists === 'function' && Elixir_ProductFormExists();
			}

			function currentVariant() {
				var variants = window.__productVariants || window.__elixirProductVariants || [];
				var id = Elixir_GetProductFormVariantId();
				for (var i = 0; i < variants.length; i++) {
					if (String(variants[i].id) === String(id)) return variants[i];
				}
				return variants[0] || null;
			}

			/* A Subscribe & Save block on the page owns plan selection; only apply our own
			   default when there is no subscription UI to defer to. */
			function ownsPlan() {
				return subscribeByDefault && !document.querySelector(subscribeUiSelector);
			}

			function applyDefaultPlan() {
				if (!ownsPlan() || !formReady()) return;
				Elixir_SetProductFormSellingPlan(planId);
				var variant = currentVariant();
				if (variant && typeof window.Elixir_SetSubscriptionContext === 'function') {
					window.Elixir_SetSubscriptionContext(planId, variant, plan);
				}
			}

			function syncState() {
				var subscribed = formReady() && !!Elixir_GetProductFormSellingPlan();
				root.classList.toggle('is-subscribed', subscribed);
			}

			var link = root.querySelector('[data-atc-onetime]');
			if (link) {
				link.addEventListener('click', function (event) {
					event.preventDefault();
					if (!formReady()) return;
					if (Elixir_ProductFormSubmitOneTime()) {
						link.setAttribute('aria-busy', 'true');
						var btn = document.getElementById('ProductSubmitButton-' + sectionId);
						var release = function () {
							if (btn && btn.hasAttribute('aria-disabled')) return;
							link.removeAttribute('aria-busy');
							observer.disconnect();
						};
						var observer = new MutationObserver(release);
						if (btn) observer.observe(btn, { attributes: true, attributeFilter: ['aria-disabled'] });
						setTimeout(function () { link.removeAttribute('aria-busy'); observer.disconnect(); }, 8000);
					}
				});
			}

			var form = formReady() ? Elixir_GetProductForm() : null;
			if (form) {
				form.addEventListener('change', function (event) {
					if (event.target && event.target.name === 'selling_plan') syncState();
				});
			}
			document.addEventListener('subscriptionContext:updated', syncState);
			document.addEventListener('variant:change', function () { setTimeout(applyDefaultPlan, 0); });
			document.addEventListener('simple-variant-picker:variantChange', function () { setTimeout(applyDefaultPlan, 0); });

			if (window.__elixirPricingReady) {
				applyDefaultPlan();
			} else {
				document.addEventListener('elixir-pricing-ready', applyDefaultPlan, { once: true });
				if (ownsPlan() && formReady()) Elixir_SetProductFormSellingPlan(planId);
			}
			syncState();
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initAtcSubscription);
		} else {
			initAtcSubscription();
		}

		/* ── Price sync handled by elixir-price-sync.js ─────────── */
		/* Initial price rendered by Liquid; JS syncs on variant/qty/subscription changes. */
	}

	function initAll() {
		document.querySelectorAll('.pdp-atc-block-root[data-atc-section-id]').forEach(initBlock);
	}

	initAll();
	document.addEventListener('shopify:section:load', initAll);
	document.addEventListener('shopify:block:select', initAll);
})();
